import {useTranslation} from 'react-i18next';
import {useModalControls} from 'hooks';
import ModalSheet from 'components/common/ModalSheet';
import ShareRegistrationLink from 'components/ModalSheets/ShareRegistrationLink';
import Button from 'components/common/Button';

type Props = {
  className?: string;
  icon?: React.ReactNode;
};
export const ShareRegistrationLinkButton = ({className, icon = null}: Props) => {
  const {t} = useTranslation();

  const {isOpen, closeModal, openModal} = useModalControls();

  return (
    <>
      <Button
        className={className}
        onClick={openModal}
        link
        label={t('share_registration_link')}
        customIcon={icon}
        iconProps={{position: 'left'}}
      />
      <ModalSheet
        isOpenModalSheet={isOpen}
        handleCloseModal={closeModal}
        withCloseButton
        maxWidth={'375px'}
      >
        <ShareRegistrationLink />
      </ModalSheet>
    </>
  );
};
